import React from "react";
import ReCAPTCHA from 'react-google-recaptcha'
import { useState } from 'react';
import MouseParticles from 'react-mouse-particles';
import ReactPlayer from 'react-player'
import './App.css';



const App = () => {
  
  const [verified, setVerified] =  useState(false);
  const onChange = (value) => {
    console.log('Captcha value:', value);
    console.log('smash time');
    handleSubmit();
  }

  const handleSubmit = async() => { 
  const shoes = {smash: "go"}
  alert("thank you for smashing... but this event happened in the past")
  // const response = await fetch('http://dumbidea.ngrok.io/smash', {
  //    mode: 'no-cors',
  //    method: 'POST',
  //    headers: {
  //     'Content-Type':'application/json'
  //   },
  //   body: JSON.stringify(shoes)
  // });
  setVerified(false)
};


  return (
    <>
          <MouseParticles
            g={1}
            num={5}
            color="random"
            cull="col,image-wrapper"
            life={5}>
          </MouseParticles>
          <div class="fml">



            <div class="texty">Congrats on your retirement!</div>
            <div class="youtubesparent">
            <ReactPlayer playing url={[`${process.env.PUBLIC_URL}/pinatabot1.sm.mp4`]} autoplay={true} controls={true} width={1024} height={634}/>
              {/* <iframe 
                class="youtubes"
                src="https://www.youtube.com/embed/ScL-pzeHyGU?&autoplay=1"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
              </iframe> */}

              </div>

              <div class="lower">
                
                {verified ? <ReCAPTCHA
                sitekey="6LffMJMdAAAAAHHB7s20TKv1Pw-z3Qrkqb0L_SNa"
                onChange={onChange}
                theme='dark'
                type='image'
              /> : <button class="button" onClick={() => setVerified(true)}>Smash</button>}
              </div>
          </div>
          
          </>
        );
}

export default App;
